import { SxProps, Theme } from '@mui/material'

import { CELL_HEIGHT } from 'components/Table/constants'

export const MIN_ESTIMATED_STICKY_ROWS = 10

type Props =
  | {
      headerGroups: number
      variant: 'tableContainer'
    }
  | {
      variant: 'tableHead'
    }

type Return = SxProps<Theme>

export const useStickyHeaderStyles = (props: Props): Return => {
  switch (props.variant) {
    case 'tableContainer': {
      const { headerGroups } = props

      return {
        height: CELL_HEIGHT * (MIN_ESTIMATED_STICKY_ROWS + headerGroups),
      }
    }

    case 'tableHead':
      return {
        boxShadow: '0 5px 5px -5px grey',
        position: 'sticky',
        top: 0,
        zIndex: theme => theme.zIndex.tableHeaderPinned,
      }
  }
}
